// SLATE — classic minimal accordion. Hairline dividers, optional category
// sections. Reference implementation for the template pattern:
//  - accordion items: <div class="fq-acc"><button class="fq-qbtn" aria-expanded>…<panel>
//  - all colors/fonts/radii via ctx.v (CSS variables)
//  - selectors in css use the .FQM marker (rewritten to scoped root)
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const slate = {
    id: 'slate',
    name: 'Slate',
    tag: 'Classic accordion',
    styleTag: 'Minimal',
    description: 'A quiet, typographic accordion that disappears into any page. Hairline dividers, smooth height animation, and nothing to distract from your answers. The safe, excellent default.',
    layout: 'accordion',
    defaultAccent: '#4a6cf7',
    darkDefault: false,
    catSupport: 'optional',
    features: ['accordion'],
    render(ctx) {
        const groups = ctx.groups
            .map((g) => `${g.name ? `<h3 class="fq-cat">${g.name}</h3>` : ''}
<div class="fq-list">
${g.items.map((it) => itemHtml(ctx, it)).join('\n')}
</div>`)
            .join('\n');
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  ${groups}
</div>`;
        const css = `
.FQM .fq-wrap{max-width:720px;margin:0 auto}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:34px;font-weight:600;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:16px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-cat{margin:30px 0 0;font-size:12.5px;font-weight:700;letter-spacing:0.09em;text-transform:uppercase;color:${ctx.v.accent}}
.FQM .fq-list{margin-top:14px;border-top:1px solid ${ctx.v.border}}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:16px;padding:19px 4px;font-size:17px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:13px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 44px 20px 4px;font-size:15.5px;line-height:1.65;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default slate;
